export default "__VITE_PUBLIC_ASSET__c3e0d66d__"